import * as React from "react";

import { Error500Page } from "tabler-react";

type Props = {};

const Error500 = () => <Error500Page />;

export default Error500;
